export default __webpack_public_path__ + "static/media/18.83c70869.png";